export const RoleDescriptions = {
  'front-office': 'admin.userTable.front-office.label',
  'back-office': 'admin.userTable.back-office.label',
  'back-office-direct': 'admin.userTable.back-office-direct.label',
  'admin': 'admin.userTable.admin.label',
  'compliance': 'admin.userTable.compliance.label',
  'revision': 'admin.userTable.revision.label',
  'pw-reset': 'admin.userTable.pw-reset.label',
};
